<template>
  <Transition name="fade">
    <div
      v-show="isContextOpen"
      ref="context"
      :style="{
        left: `${contextLeft}px`,
        top: `${contextTop}px`,
      }"
      class="table-context-menu"
    >
      <div
        :class="{'context-tab-disabled': disabledActions.drilldown}"
        class="item"
        @click="handleReportAction('=')"
      >
        <UiIcon
          name="shuffle"
          class="context-icon"
        />
        <span>{{ $t('customReports.drilldown') }}</span>
      </div>
      <div
        :class="{'context-tab-disabled': disabledActions.exclude}"
        class="item"
        @click="handleReportAction('!=')"
      >
        <span>
          <UiIcon
            name="page-break"
            class="mr-2"
          />
          {{ $t('customReports.exclude') }}
        </span>
      </div>
      <a
        class="item"
        :href="getExportLink('csv')"
        @click="hideContextMenu"
      >
        <UiIcon
          name="file-csv"
          substyle="fal"
          class="ml-2 mr-8"
        />
        {{ $t('customReports.exportCsv') }}
      </a>
      <a
        class="item"
        :href="getExportLink('xlsx')"
        @click="hideContextMenu"
      >
        <UiIcon
          name="file-spreadsheet"
          substyle="fal"
          class="ml-2 mr-8"
        />
        {{ $t('customReports.exportXlsx') }}
      </a>
    </div>
  </Transition>
</template>

<script>
export default {
  props: {
    disabledActions: {
      type: Object,
      default: () => ({}),
    },
    exportUrls: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['before-create-report'],
  data() {
    return {
      isContextOpen: false,
      contextTop: 0,
      contextLeft: 0,
    };
  },
  async mounted() {
    document.addEventListener('click', this.clickOutside, false);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.clickOutside, false);
  },
  methods: {
    clickOutside(e) {
      if (this.$refs.context && !this.$refs.context.contains(e.target)) {
        this.hideContextMenu();
      }
    },
    showContextMenu(event) {
      this.contextLeft = event.clientX;
      this.contextTop = event.clientY;
      this.isContextOpen = true;
    },
    hideContextMenu() {
      this.isContextOpen = false;
    },
    getExportLink(format) {
      return (this.exportUrls || {})[format];
    },
    handleReportAction(op) {
      this.$emit('before-create-report', null, op);
      this.hideContextMenu();
    },
  },
};
</script>
